import React from "react";
import { ResumoGeral } from "../CaixaPage";
import BoxComponent from "../../../components/Box/BoxComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import { formatNumberToDinheiro } from "../../../utils/dinheiro";
import CaixaResumoComponent from "./CaixaResumoComponent";
import DataGridComponent from "../../../components/Table/DataGridComponent";
import { mockCaixaMovimentacoes } from "../data";
import { formatDateTimePtBr } from "../../../utils/datas";

interface CaixaInfosProps {
    resumo: ResumoGeral;
    onClickImpressora: () => void;
}

const CaixaInfosComponent = (props: CaixaInfosProps) => {
    return <BoxComponent
        component="section"
        sx={{
            display: "flex",
            borderRadius: "8px",
            gap: 1.6,
            width: "100%"
        }}
    >
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                borderRadius: "8px",
                // padding: 2,
                gap: 1.6,
                flex: 3
            }}
        >
            <DataGridComponent
                rows={mockCaixaMovimentacoes}
                columns={[
                    {
                        field: "data_hora", headerName: "Data/Hora", valueFormatter: (value) => formatDateTimePtBr(value), flex: 1
                    },
                    { field: "descricao", headerName: "Descrição", flex: 1 },
                    { field: "valor", headerName: "Valor", valueFormatter: (value) => formatNumberToDinheiro(value), flex: 1 },
                    { field: "forma_pagamento", headerName: "Forma de Pagamento", flex: 1 },
                    {
                        field: "tipo", headerName: "Tipo", flex: 1,
                        renderCell: (params) => {
                            const tipo = params.value;

                            const styles: Record<string, React.CSSProperties> = {
                                Abertura: { backgroundColor: "#E3F2FD", color: "#1976D2" },
                                Venda: { backgroundColor: "#E8F5E9", color: "#2E7D32" },
                                Suprimento: { backgroundColor: "#FFF3E0", color: "#EF6C00" },
                                Sangria: { backgroundColor: "#FFEBEE", color: "#C62828" },
                            };

                            return (
                                <BoxComponent
                                    component="div"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        width: "100%",
                                    }}
                                >
                                    <TypographyComponent
                                        variant="body2"
                                        sx={{
                                            padding: "4px 8px",
                                            borderRadius: 8,
                                            fontSize: 12,
                                            fontWeight: 500,
                                            ...styles[tipo],
                                        }}
                                    >
                                        {tipo}
                                    </TypographyComponent>
                                </BoxComponent>
                            );
                        },
                    },
                    { field: "usuario", headerName: "Usuário", flex: 1 },
                ]}
                pagination={{ page: 0, pageSize: 5 }}
                pageSizeOptions={[5, 10]}
            />
        </BoxComponent>

        <CaixaResumoComponent
            resumo={props.resumo}
            onClick={props.onClickImpressora}
        />

    </BoxComponent>;
}

export default CaixaInfosComponent;